import { useContext, useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import { UserContext } from '../../context/UserContext';
import AccessDenied from '../shared/AccessDenied';
import LoadingScreen from '../../components/shared/loading/LoadingScreen';
import ReportFrame from '../../components/forecasting_risk/ReportFrame';
import AskSyntiro from '../../components/forecasting_risk/AskSyntiro';

export default function ForecastingView() {
  const { user } = useContext(UserContext);
  const [hasAccess, setHasAccess] = useState<boolean | null>(null);

  useEffect(() => {
    setHasAccess(user ? (user.super_admin ?? false) : null);
  }, [user]);

  return !user || hasAccess === null ? (
    <LoadingScreen />
  ) : !hasAccess ? (
    <AccessDenied />
  ) : (
    <Box
      sx={{ display: 'flex', flex: 1, minHeight: 0, overflow: 'hidden', mx: -3, mt: -3, mb: -3 }}
    >
      <AskSyntiro reportId="forecasting">
        <ReportFrame reportId="forecasting" title="Forecasting Report" />
      </AskSyntiro>
    </Box>
  );
}
